<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.id)" class="btn-grey"><i
                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-20">
        <div class="font-bold">Rekening</div>
        <hr class="short-line left">
        <form @submit.prevent="editCreditCard('editCreditCard')" data-vv-scope="editCreditCard">
          <div class="row">
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Rekening No</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataCreditCard.rekening_no"
                    name="credit_card_holder_name" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Rekening Bank</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataCreditCard.rekening_bank"
                    name="credit_card_holder_name" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>
            <div class="col-lg-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Rekening Name</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom" v-model="dataCreditCard.rekening_name"
                    name="credit_card_holder_name" type="text"></b-form-input>
                </b-col>
              </b-row>
            </div>

          </div>
          <div class="text-right mt-15">
            <button v-if="!isViewOnly" type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'addSales',
  components: {
    ModelSelect
  },
  data: function () {
    return {
      loadingActive: false,
      dataCreditCard: {
        rekening_no: '',
        rekening_name: '',
        rekening_bank: '',
      },
      isViewOnly: false
    }
  },
  methods: {
    editCreditCard(event) {
      this.$validator.validateAll(event).then(async result => {
        if (result) {

          this.$swal({
            title: 'Are you sure?',
            text: 'You are about to submit this data and waiting for approval',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save now!',
            cancelButtonText: 'No, Cancel it!',
            showCloseButton: true,
            showLoaderOnConfirm: false
          }).then((confirm) => {
            if (confirm.value) {
              const payload = {
                member_id: this.$route.query.id,
                request_data: this.dataCreditCard,
                action: 'EDIT',
                notes: `Update Rekening`,
                description: `Request to update rekening with number ${this.dataCreditCard.rekening_no} and name ${this.dataCreditCard.rekening_name}`,
              }
              this.loadingActive = true

              axios.post('crm/v1/approval_request/module_member', payload).then(response => {
                this.loadingActive = false
                this.$swal('Successfully!', 'Data has been submitted and waiting for approval!', 'success')
                this.fetchData()
              }).catch((error) => {
                this.loadingActive = false
                console.log('Error', error)
                this.$swal('Failed!', 'Failed or Data has been waiting for approval!', 'error')
              })
            } else {
              this.$swal('Cancelled', 'Your file is still intact', 'info')
            }
          })


          // remark when approval future is ready
          // try{
          //   const updateCard = await axios.put('fitness/v1/member/' + this.$route.query.id, this.dataCreditCard)
          //   this.$router.push('/memberEntry/edit?id=' + this.$route.query.id)
          //   this.$toast.success('data saved successfully!', 'Success', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // } catch(error){
          //   // console.log('error', error)
          //   this.$toast.success('cant saved data!', 'Error', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // }
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    fetchData() {
      axios.get('fitness/v1/member/' + this.$route.query.id).then(response => {
        this.dataCreditCard.rekening_no = response.data.data.rekening_no
        this.dataCreditCard.rekening_bank = response.data.data.rekening_bank
        this.dataCreditCard.rekening_name = response.data.data.rekening_name

        // console.log('liat', response.data.data)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()

    const isclbManager = Auth.Session.get().paradigm_role_mapping_id
    if (isclbManager.includes(17)) {
      this.isViewOnly = true
    }
  }
}
</script>

<style></style>
